import { DISCOUNT_UNITS, FIXED, PERCENT } from '../constants/constants';
import getPureCurrencyRepresentation from './getPureCurrencyRepresentation';

/**
 * Returns formatted price amount (primarily for discounted amount).
 *
 * @example
 * // returns '($7.5 OFF)' or '(10% OFF)' depending on "period.unit"
 * getFormattedAmount(
 *                    period.discount,
 *                    '(<value:auto> OFF)',
 *                    {
 *                      unit: period.unit,
 *                      currency: currency.sign
 *                    })
 *
 * @param value
 * @param {string} format - the base string with inclusions <key>. Dedicated <value:auto> inclusion
 *                          can be used to format amount supplied in "value" as a percentage or
 *                          fixed amount in specified currency.
 * @param dict {{[currencyConvert], [currencyRate], [value], [unit], [currency]}}
 *  - object of key-values for hydration of "format" string.
 * @return {`${string} %`|`${string} ${*}`|string}
 */
export default (value, format, dict) => {
    dict = dict || {};
    dict.value = value;
    if (!!dict?.currencyConvert && dict?.currencyRate) {
        dict.value = Math.round((dict.value * dict?.currencyRate) * 100 + Number.EPSILON) / 100;
    }
    const currencyPure = getPureCurrencyRepresentation(dict?.currency);

    if (dict?.unit) {
        if (DISCOUNT_UNITS[dict.unit] === FIXED) {
            dict['value:auto']
                = `${currencyPure}${dict.value}`;
        } else {
            dict['value:auto'] = `${dict.value}${PERCENT}`;
        }
    }
    dict[FIXED] = currencyPure;
    dict[PERCENT] = PERCENT;

    // Replace any available <key> reference with the actual value from dict.
    return format.replace(/<([^>]+?)>/gi, (match, group) => {
        if (group in dict) {
            return dict[group];
        }
    });
}
